module.exports = __webpack_public_path__ + "static/img/05.5a50c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution/logistics-automation/05.jpg
// module id = /NRF
// module chunks = 1